import React, {Component} from "react";
import {connect} from 'react-redux';
import {
	Box,
	Button,
	Checkbox,
	CircularProgress,
	FormControlLabel,
	FormGroup,
	IconButton,
	Stack,
	Tooltip,
	Typography
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import {getAnnotationFeature, getAnnotationFromPoints} from "../utils/annotations_app_utils";
import {polygonDrawingKey} from "../drawer/draw_tool_keys";
import VectorSource from "ol/source/Vector";
import {message} from "antd";
import {DeepBioConstants, Loader} from "../../../utils/const";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {updateDeepBioDisplayColor, updateDeepBioResultsDisplayed} from "../../../redux_actions/deepbio.action";
import {updateActiveAnnoDrawer} from "../../../redux_actions/gamma.state.action";
import {retrieveAnnotations} from "../../../redux_actions/maps.state.action";
import AnnotationsExpandableList from "./AnnotationsExpandableList";
import {getEyeCheckbox, LoadingText} from "../components/components";
import {getDeepBioResultComponent, runDeepBioAI, uploadSlide} from "../utils/deepBioAppUtils";
import {Biotech, VisibilityOff} from "@mui/icons-material";
import {locateAnnotationOnMap} from "../utils/map_utils";
import {error_manager} from "../../../helper/error_manager";
import {get} from "../../../helper/request";
import {isCloud, isNull, notNull} from "../../../utils/utils";
import {annotationsApp, deepBioApp} from "../app_maker";

class DeepBioApp extends Component {
	constructor(props) {
		super(props);

		this.drawer = deepBioApp.drawer;

		this.state = {
			uploaded: false,
			upload_status: "",
            annotations_in_queue: [],
        }
    }

    getSlideUploadStatus = () => {
		let url = `/api/get_deep_bio_upload_stage/?id=${this.props.slide?.id}`
	    get(url).then(res => {
		    let uploaded = res['uploaded']
		    if (uploaded !== 1) {
			    this.setState({
				    uploaded: uploaded,
			    });
		    } else {
			    this.setState({
				    uploaded: uploaded,
				    upload_status: res['status'],
			    });
		    }
	    });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.deepBioData !== this.props.deepBioData)
            this.updateDeepBioResultsDisplayed();

		if (isNull(prevProps.slide) && notNull(this.props.slide)) {
			this.getSlideUploadStatus();
			this.getWholeSlideAIStatus();
		}
    }

    updateDeepBioResultsDisplayed = () => {
	    let selected = this.props.deepBioData.ai_results_displayed;
		let vector = this.props.slidemap.getLayers().getArray()
			.find(layer => layer.get('id') === deepBioApp.id);
		let annotations_list = this.deepBioAnnotations;
	    let filter = this.props.deepBioData.active_filter;
	    let features = [];
	    for (let i = 0; i < selected.length; i++)
		    if (selected[i] === "ALL") {
			    let contours = (this.state.whole_slide_ai.result || {})['heatmap'];
			    if (!contours) return;
			    for (let i = 0; i < contours.length; i++)
				    if (filter === "ALL" || filter.toLowerCase() === contours[i].color.toLowerCase()) {
					    let color = contours[i]['color'];
					    let bounds = contours[i]['contour'];
                        let new_anno = getAnnotationFromPoints(
                            color, 0, 0, polygonDrawingKey, bounds, [0,0], 2, 0,
	                        this.props.slide.id
                        )
                        new_anno.title = contours[i]['label']
                        let new_anno_feature = getAnnotationFeature(new_anno);
                        new_anno_feature.set('parent_anno', "ALL");
                        features.push(new_anno_feature);
                    }
            } else
                for(let j=0;j<annotations_list.length; j++)
                    if(annotations_list[j].id === selected[i]) {
                        let annotation = annotations_list[j];
                        let contours = (annotation['result']||{})['heatmap'];
                        if(!contours) continue;
                        for(let i=0; i<contours.length; i++)
                            if (filter === "ALL" || filter.toLowerCase() === contours[i].color.toLowerCase()) {
                                let color = contours[i]['color'];
                                let bounds = contours[i]['contour'];
                                let new_anno = getAnnotationFromPoints(
                                    color, 0, 0, polygonDrawingKey, bounds, [0,0], 2, 0,
	                                this.props.slide.id
                                )
                                new_anno.title = contours[i]['label']
                                let new_anno_feature = getAnnotationFeature(new_anno);
                                new_anno_feature.set('parent_anno', annotations_list[j].id);
                                features.push(new_anno_feature);
                            }
                    }
        vector.setSource(
            new VectorSource({
                features: features,
                wrapX: false,
            })
        )
    }

	getWholeSlideAIStatus = () =>
		get(`/api/get_deep_bio_whole_slide_run_status/?id=${this.props.slide?.id}`)
			.then(whole_slide_ai => this.setState({whole_slide_ai,}))
			.catch(error => error_manager("Error in getting deep bio status", error));

    componentDidMount() {
        // here we get the status of the slide i.e in what state the slide currently is
        // assume its uploaded
        // in our backend api before returning whether slide is already present or not we will check time too and return accordingly no uploading afterwards
		if (notNull(this.props.slide)) {
			this.getSlideUploadStatus();
			this.getWholeSlideAIStatus();
		}
        //change anno drawer on mounting only
	    this.props.dispatch(updateActiveAnnoDrawer(deepBioApp.drawer))
    }

    componentWillUnmount() {
	    this.props.dispatch(updateActiveAnnoDrawer(annotationsApp.drawer));
    }

    runAIOnSelectedAnnotations = (selected_annotations) => {
	    if (this.state.uploaded !== 2) {
		    message.info("Please Upload Slide First")
		    return;
	    }
	    let slide = this.props.slide;
	    let selected_annotation_ids = selected_annotations.map(annotation => annotation.id)
		    .filter(id => !this.state.annotations_in_queue.includes(id));
	    if (selected_annotation_ids.includes("ALL")) {
		    selected_annotation_ids = ["ALL"];
	    }
	    this.setState({
		    annotations_in_queue: [...this.state.annotations_in_queue, ...selected_annotation_ids],
	    });
	    return runDeepBioAI(slide.morphle_id, slide.id, selected_annotation_ids, () => {
		    this.setState({
			    annotations_in_queue: this.state.annotations_in_queue.filter(id => !selected_annotation_ids.includes(id)),
		    });
            this.onRefreshApp();
        });
    }

    getTopComponent = () =>
        <Stack direction={"row"} justifyContent={"space-between"}>
            {this.state.uploaded === 0 ?
	            <FormGroup>
					<Stack direction={"row"} justifyContent={"space-between"}>
						<Button variant={"contained"} color={"secondary"} sx={{width: '190px'}} onClick={() =>
							uploadSlide(this.props.slide.id, this.defaultRunAI, this.onRefreshApp)}>
							Upload Slide
						</Button>
						<IconButton onClick={this.onRefreshApp} color={"secondary"}
									sx={{marginLeft: '50px'}}><RefreshIcon/></IconButton>
					</Stack>
					<FormControlLabel control={<Checkbox defaultValue={false} sx={{marginLeft: '10px'}} onClick={e =>
						this.defaultRunAI = e.target.checked} color={"secondary"} size={"small"}/>}
									  label="Run AI with upload"/>
				</FormGroup> :
                <Button sx={{width:'98%', backgroundColor:"rgba(108,122,137,1)!important",
                    color:'rgba(255,255,255,1) !important'}} disabled>
                    {this.state.uploaded === 1 ? this.state.upload_status : "Upload Completed"}
                </Button>
            }
        </Stack>

    onRefreshApp = () => {
	    this.getSlideUploadStatus();
	    this.props.dispatch(retrieveAnnotations(this.props.activeMapId, this.props.slide.id));
	    this.getWholeSlideAIStatus();
    }

    onEyeCheckbox = (annotation, checked) => {
        if (checked)
            this.props.dispatch(updateDeepBioResultsDisplayed([annotation.id,
                ...this.props.deepBioData.ai_results_displayed.filter(id => id !== annotation.id)]));
        else this.props.dispatch(updateDeepBioResultsDisplayed(
            [...this.props.deepBioData.ai_results_displayed.filter(id => id !== annotation.id)]));
    }

    getDeepBioAnnotationAction = (annotation) => {
	    if (this.state.annotations_in_queue.includes(annotation.id))
		    return <CircularProgress color={"secondary"} size={20} sx={{marginX: 1}}/>;
	    let deepBioAnalysis = annotation.deepbio_analysis;
	    return deepBioAnalysis && deepBioAnalysis['status'] !== 'NOT_RUN' ?
		    deepBioAnalysis['status'] === 'FINISHED' ?
			    getEyeCheckbox(undefined, false,
				    e => this.onEyeCheckbox(annotation, e.target.checked), <VisibilityOff/>) :
			    <Tooltip title={deepBioAnalysis['status']} placement="top-start">
				    <Box sx={{position: 'relative', display: 'inline-flex', marginLeft: "-14px"}}>
					    <CircularProgress variant="determinate" value={deepBioAnalysis['progress']}
					                      color={"secondary"}/>
					    <Box
						    sx={{
							    top: 0,
							    left: 0,
							    bottom: 0,
							    right: 0,
							    position: 'absolute',
							    display: 'flex',
							    alignItems: 'center',
							    justifyContent: 'center',
						    }}
					    >
						    <Typography variant="caption" component="div" color="text.secondary">
							    {`${Math.round(deepBioAnalysis['progress'])}%`}
						    </Typography>
					    </Box>
				    </Box>
			    </Tooltip> :
		    <Tooltip title={isCloud() ? "Not available on cloud" : this.state.uploaded === 2 ? "Run AI" :
			    this.state.uploaded === 1 ? "Waiting for slide to upload" : "Upload Slide to Run AI"}
		             placement={"bottom"}>
			    <IconButton onClick={() => (this.runAIOnSelectedAnnotations([annotation]))}
			                disabled={isCloud() || this.state.uploaded !== 2}
			                color={"secondary"}><PlayArrowIcon/></IconButton>
		    </Tooltip>
    }

    render() {
		if (this.props.loadingState.loading) {
			return <Loader/>
		}
	    if (!(this.props.annotationState || {}).annotations || !this.state.whole_slide_ai) return <LoadingText/>;

	    this.deepBioAnnotations = this.props.annotationState.annotations.filter(annotation =>
		    annotation.anno_drawer === this.drawer);

	    let annotations = [{
		    id: "ALL",
		    title: "Whole Slide",
		    icon: <Biotech/>,
		    result: this.state.whole_slide_ai.result,
		    deepbio_analysis: {
			    status: this.state.whole_slide_ai.status,
			    progress: this.state.whole_slide_ai.progress,
		    },
		    color: "ALL",
		    onlyShowResult: true,
	    }, ...this.deepBioAnnotations];

        annotations.forEach(annotation => {
            annotation.actionComponent = this.getDeepBioAnnotationAction(annotation);
            annotation.resultComponent = getDeepBioResultComponent((annotation.result || {}).summary);
        });

        let annotationsComponent = <AnnotationsExpandableList annotations={annotations}
                                                              slideId={this.props.slide.id}
                                                              colors={DeepBioConstants.LABELS}
                                                              showColorLabels={true}
															  showMergeAnnotations={false}
															  deselectPostAction={true}
                                                              actionOnSelected={this.runAIOnSelectedAnnotations}
                                                              actionTooltip={"Run AI on selected Annotations"}
                                                              onColorFilter={color =>
                                                                  this.props.dispatch(updateDeepBioDisplayColor(color))}
                                                              onAnnotationClick={(annotation) =>
																  locateAnnotationOnMap(this.props.slidemap,
																	  annotation, false)}
        />

        return <Stack direction={"column"} spacing={1}>
	        {!isCloud() && this.getTopComponent()}
	        {annotationsComponent}
        </Stack>
    }
}

const mapStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
	let {slide, slidemap, annotationState} = state.mapsStateReducer[activeMapId] ?? {};
	let deepBioData = state.deepBioReducer;
	let loadingState = state.slideLoadingReducer;
	return {activeMapId, slide, slidemap, annotationState, deepBioData, loadingState};
}

export default connect(mapStateToProps)(DeepBioApp);
